import { render, staticRenderFns } from "./Back.vue?vue&type=template&id=0bc78159&scoped=true"
import script from "./Back.vue?vue&type=script&lang=js"
export * from "./Back.vue?vue&type=script&lang=js"
import style0 from "./Back.vue?vue&type=style&index=0&id=0bc78159&prod&scoped=true&lang=css"
import style1 from "./Back.vue?vue&type=style&index=1&id=0bc78159&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc78159",
  null
  
)

export default component.exports